import React from "react";
import { Link } from "react-router-dom";
import { Home as HomeIcon, ArrowLeft } from "lucide-react";
import SEO from "../../components/site/SEO";

export default function NotFound() {
  return (
    <>
      <SEO title="Page not found — Wonder Washers" description="The page you're looking for doesn't exist." />
      <section className="max-w-3xl mx-auto py-24 md:py-32 px-6 text-center" data-testid="not-found-page">
        <div className="text-xs font-subhead tracking-widest text-[color:var(--ww-red)] uppercase mb-3">Error 404</div>
        <h1 className="font-display uppercase text-6xl md:text-7xl text-[color:var(--ww-navy)] leading-none">
          Page not<br /> found.
        </h1>
        <p className="mt-6 text-slate-600 leading-relaxed max-w-lg mx-auto">
          The page you're looking for isn't here. Maybe the link is old, or you followed a bookmark that no longer exists.
        </p>
        <div className="mt-8 flex flex-wrap gap-3 justify-center">
          <Link to="/" className="ww-btn-primary inline-flex items-center gap-2" data-testid="not-found-home-btn">
            <HomeIcon className="h-4 w-4" /> Back home
          </Link>
          <Link to="/book" className="ww-btn-outline inline-flex items-center gap-2" data-testid="not-found-book-btn">
            <ArrowLeft className="h-4 w-4" /> Book online
          </Link>
        </div>
      </section>
    </>
  );
}
